<template>
  <div
    class="flex order-first lg:order-none w-full title-font font-medium items-center lg:items-center lg:justify-center mb-4 md:mb-0"
  >
    <img
      src="@/assets/icons/hospital.svg"
      style="height: 40px; margin-top: 10px; margin-bottom: 10px"
      alt="logo"
    />

    <span class="ml-3 text-xl">Title</span>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
